import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState } from ".";

type ThunkAwareDispatch = <T>(
  action: T,
) => T extends (...args: any) => infer R ? R : T;

export const useAppDispatch = () => useDispatch() as ThunkAwareDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
